import React from 'react';

function GlowRibbon() {
  return (
    <div>
      <div className='ribbon-wrapper top-2'>
        <div className='glow'></div>
        <div className='ribbon-front animate-gradient bg-gradient-to-r from-brand-secondary via-brand-primary-border to-brand-secondary bg-[length:var(--bg-size)_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] text-white font-bold text-md flex items-center justify-center uppercase tracking-wider'>
          Coming Soon!
        </div>
        <div className='ribbon-edge-topleft'></div>
        <div className='ribbon-edge-topright'></div>
        <div className='ribbon-edge-bottomleft'></div>
        <div className='ribbon-edge-bottomright'></div>
      </div>
    </div>
  );
}

export default GlowRibbon;
